module.exports = __webpack_public_path__ + "static/michele-cf63828409a56f9c995ec365b7e69fb6.jpg";